export type SkyMapVec3 = [number, number, number];

/** The one explicit conversion from COLMAP's axes into Three.js's Y-up space. */
export const colmapToViewer = ([x, y, z]: SkyMapVec3): SkyMapVec3 => [x, -y, -z];
